<template>
  <div class="mb-4">
    <h4 class="mb-3">Current Bike tests</h4>

    <div class="row" v-if="current.length">
      <div
        class="col-md-6 col-xl-3 mb-3"
        v-bind:key="test.identifier"
        v-for="test in current"
      >
        <div class="card h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div>
              <div><strong>Technician:</strong> {{ test.technician }}</div>
              <div><strong>Registration:</strong> {{ test.registration }}</div>
            </div>
            <stopwatch-icon :time="test.display" :size="90"></stopwatch-icon>
          </div>
        </div>
      </div>
    </div>
    <p class="text-muted" v-else>
      No bikes are currently out on a road test.
    </p>

    <template v-if="overdue.length">
      <h4 class="mb-3 text-danger">15 min+ Alert</h4>

      <div class="row">
        <div
          class="col-md-6 col-xl-3 mb-3"
          v-bind:key="test.identifier"
          v-for="test in overdue"
        >
          <div class="card h-100 border-danger">
            <div class="card-body">
              <div><strong>Technician:</strong> {{ test.technician }}</div>
              <div><strong>Registration:</strong> {{ test.registration }}</div>
              <div class="text-danger">
                Out on a road test for {{ test.display }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import StopwatchIcon from './StopwatchIcon.vue';
import { formatSeconds } from './formatSeconds';

const ALERT_AFTER_SECONDS = 15 * 60;
const REFRESH_EVERY_MS = 10000;

export default {
  components: {
    StopwatchIcon
  },

  data() {
    return {
      tests: [],
      fetchedAt: Date.now(),
      now: Date.now(),
      poller: null,
      ticker: null
    };
  },

  computed: {
    // The elapsed time is the time the server reported plus the time since
    // then, so it does not depend on the clock of this computer.
    current() {
      const waited = Math.floor((this.now - this.fetchedAt) / 1000);

      return this.tests.map(test => {
        const seconds = test.elapsed_seconds + waited;

        return { ...test, seconds, display: formatSeconds(seconds) };
      });
    },

    overdue() {
      return this.current.filter(test => test.seconds > ALERT_AFTER_SECONDS);
    }
  },

  mounted() {
    this.load();

    this.poller = setInterval(this.load, REFRESH_EVERY_MS);
    this.ticker = setInterval(() => (this.now = Date.now()), 1000);
  },

  beforeDestroy() {
    clearInterval(this.poller);
    clearInterval(this.ticker);
  },

  methods: {
    load() {
      window.Ajax.get('pdi/road-tests/active')
        .then(response => {
          this.tests = response.data.data;
          this.fetchedAt = Date.now();
          this.now = this.fetchedAt;
        })
        .catch(() => {
          // Keep showing the last result, the next refresh will try again
        });
    }
  }
};
</script>
